export default __webpack_public_path__ + "static/media/Rubik-Bold.31bbd4d2.ttf";